import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import {
  BATCH_STATUS_ABORTED,
  BATCH_STATUS_FAILED,
  BATCH_STATUS_COMPLETED,
  getBatchJobId,
} from '../../services/BatchService';

export default () => {
  const BatchButtons = ({ row: batch, batchService, onAbortBatch, onRetryBatch, onLogBatch }) => {
    const handleRetryBatch = () => onRetryBatch(batch);
    const handleAbortBatch = () => onAbortBatch(batch);
    const handleLog = () => onLogBatch(batch);
    const jobId = getBatchJobId(batch);
    let label;
    let onClick;
    switch (batch.status) {
      case BATCH_STATUS_COMPLETED: break;
      case BATCH_STATUS_ABORTED:
      case BATCH_STATUS_FAILED: {
        if (!batch.discarded) {
          label = 'Retry';
          onClick = handleRetryBatch;
        }
        break;
      }
      default: {
        label = 'Abort';
        onClick = handleAbortBatch;
      }
    }
    return (
      <React.Fragment>
        <Button
          variant="outlined"
          onClick={onClick}
          id={`batch-abort-button-${batch.id}`}
          style={label ? undefined : { visibility: 'hidden' }}
        >
          {label || 'Abort'}
        </Button>
        <Button
          variant="outlined"
          disabled={!jobId}
          onClick={handleLog}
          id={`batch-log-button-${batch.id}`}
        >
          Log
        </Button>
      </React.Fragment>
    );
  };

  BatchButtons.propTypes = {
    batchService: PropTypes.shape({
      validateRetry: PropTypes.func.isRequired,
      validateAbort: PropTypes.func.isRequired,
    }).isRequired,
    row: PropTypes.shape({
      id: PropTypes.string,
    }),
    onRetryBatch: PropTypes.func.isRequired,
    onAbortBatch: PropTypes.func.isRequired,
    onLogBatch: PropTypes.func.isRequired,
  };

  BatchButtons.defaultProps = {
    row: {},
  };
  return BatchButtons;
};
